export default __webpack_public_path__ + "static/media/vo-50-percent-finished.0578934d.aac";